import { defineMessages } from 'react-intl';

type MessageKeys = 'messageErrorTitle' | 'messageError' | 'showSources' | 'hideSources';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		messageErrorTitle: {
			id: 'ai-mate.message-renderer.error-title',
			defaultMessage: 'Failed to load content',
			description:
				"Title text displayed at the top of an error message or error state when the AI assistant's message content fails to load or render in the conversation interface. Shown as the heading or title of an error notification or error state component. The purpose is to immediately communicate to the user that there was a problem loading the message content.",
		},
		messageError: {
			id: 'ai-mate.message-renderer.error',
			defaultMessage: 'Please let us know if the problem persists.',
			description:
				"Error message text displayed in the body of an error notification or error state when the AI assistant's message content fails to load or render in the conversation interface. Shown as the description text below the error title. The purpose is to guide users to report the issue if it continues to occur, helping the development team identify and fix persistent problems.",
		},
		showSources: {
			id: 'ai-mate.message-renderer.show-sources',
			defaultMessage: '{count, plural, one {Show {count} source} other {Show {count} sources}}',
			description:
				'Button label displayed on a button that expands to show the source references for an AI-generated message in the conversation interface. Shown as clickable text on a button. The ICU MessageFormat plural statement resolves to "Show {count} source" when count is 1, or "Show {count} sources" when count is 2 or more. The count placeholder will be substituted with the number of sources (e.g., "Show 1 source" or "Show 5 sources"). When clicked, it expands the message to reveal the list of sources that the AI used to generate the response. The purpose is to allow users to view the references and citations that support the AI\'s answer.',
		},
		hideSources: {
			id: 'ai-mate.message-renderer.hide-sources',
			defaultMessage: 'Hide all sources',
			description:
				'Button label displayed on a button that collapses to hide the source references for an AI-generated message in the conversation interface. Shown as clickable text on a button. When clicked, it collapses the expanded sources section and hides the list of references. The purpose is to allow users to hide the source list to reduce visual clutter and focus on the main message content.',
		},
	});

export default message;
